// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__1Jg8V","head":"ProcedureTableInfo_head__3IYT7"};